<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from "@/components/widgets/raw-data.vue";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import {cloneDeep} from 'lodash';
export default {
    props: {
        data: Object,
        suppliers: Array,
        rfqType: String
    },
    components: {
        LoadingTemplate,
        RawData,
        Multiselect
    },
    data(){
        return {
            submitted: false,
            addSupplier: {},
            abstractList: 1,
            po: {
                description: "",
                poNumber: "",
                cycle: this.$store.state.data.cycle,
                rfqSupplierId: 0,
                poDateReceived: new Date(),
                poDate: new Date(),
            },
            openPopUp: false,
        }
    },
    computed: {
        filteredRfqItems(){
            let data = this.data.rfqItems;
            if(this.data.reAward){
                data = this.data.rfqItems.filter(x => x.isReAward);
            }
            if(this.data.searchItem && this.data.searchItem != ""){
                data = data.filter(x => x.itemName.toLowerCase().includes(this.data.searchItem.toLowerCase()))
            }
            return data;
        },
    },
    methods: {
        async addMoreSupplier() {
            this.$emit('addMoreSupplier');
        },
        addSup() {
            var data = {
                rfqId: this.data.id,
                supplierId: this.addSupplier.id,
            };
            let url = this.data.supCategory == 1 ? 'rfqsupplier/AddInvitedSupplier' : 'rfqsupplier/CreateRfqSupplier';
            this.$store
                .dispatch(url, data)
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(this.data.supCategory == 1){
                        res.data.supplier = cloneDeep(this.addSupplier);
                        res.data.supplierName = this.addSupplier.name;
                        res.data.address = this.addSupplier.address;
                        this.data.invitedSuppliers.push(res.data);
                    }else{
                        res.data.supplier = cloneDeep(this.addSupplier);
                        res.data.supplierRFQ = this.data.rfqItems;
                        res.data.rfqSupplierOffers = [];
                        res.data.visible = false;
                        this.data.rfqSuppliers.push(res.data);
                    }
                    this.data.addSupplier = false;
                    this.addSupplier = {};
                    this.data.supplierMessage = `Successfully saved!`;
                    this.data.supplierMsgType = "success";
                    await this.wait(5000);
                    this.data.supplierMessage = "";
                })
                .catch(async (err) => {
                    this.data.supplierMessage = `Error adding supplier!`;
                    this.data.supplierMsgType = "danger";
                    await this.wait(5000);
                    this.data.supplierMessage = "";
                });
        },
        getTotalABC(rfqItems){
            return rfqItems.reduce((pv, cv) => {
                return pv + (cv.offer.isWinner ? parseFloat(cv.total) : 0);
            }, 0);
        },
        getTotalOffer(data) {
            return data.reduce((pv, cv) => {
                return pv + (cv.offer.isWinner ? parseFloat(cv.offer.totalAmt) : 0);
            }, 0);
        },
        didNotSubmit(supplier){
            let didNotSubmit = !supplier.didNotSubmit;
            let data = {
                id: supplier.id,
                status: didNotSubmit
            }
            this.$store
                .dispatch("rfqsupplier/RfqSupplierSubmission", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    supplier.didNotSubmit = didNotSubmit;
                    this.showToast("Successfully updated status", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        cashOnDelivery(supplier){
            let isCod = !supplier.isCod;
            let data = {
                id: supplier.id,
                status: isCod
            }
            this.$store
                .dispatch("rfqsupplier/RfqSupplierCOD", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    supplier.isCod = isCod;
                    this.showToast("Successfully updated status", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        getOffer(offer, itemId){
            let index = offer.findIndex(x => x.offer.rfqItemId === itemId);
            return offer[index];
        },
        removeSup(yId) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    let url = '';
                    let yIndex = -1;
                    if(this.data.supCategory == 1){
                        url = 'rfqsupplier/RemoveInvitedSupplier';
                        yIndex = this.data.invitedSuppliers.findIndex((x) => x.id == yId);
                    }else{
                        url = 'rfqsupplier/DeleteRfqSupplier';
                        yIndex = this.data.rfqSuppliers.findIndex((x) => x.id == yId);
                    }
                    this.$store
                        .dispatch(url, yId)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            if(this.data.supCategory == 1){
                                this.data.invitedSuppliers.splice(yIndex, 1);
                            }else{
                                this.data.rfqSuppliers.splice(yIndex, 1);
                            }
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted", "error");
                        });
                }
            });
        },
        updateOffer(data, index, id, returnDate) {
            data.forEach((item, index) => {
                item.offer.rfqSupplierId = id;
                item.offer.quantity = "" + item.offer.quantity + "";
                item.offer.unitCost = "" + item.offer.unitCost + "";
                item.filterKey = item.itemName + ' ' + item.description;
                item.offerIndex = index + 1;
                item.errorItemName = false;
                item.errorDescription = false;
                item.errorDelivery = false;
            });
            this.$emit('updateOffer', {data, index, id, returnDate})
        },
        async markAsWinner(offer) {
            let data = {
                id: offer.id,
                IsWinner: offer.isWinner ? false : true,
            };
            await this.$store
                .dispatch("rfqsupplieroffer/MarkWinnerRSO", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    offer.isWinner = data.IsWinner;
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                });
            
        },
        removeOffer(offer) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch("rfqsupplieroffer/DeleteRSO", offer.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.error, "error");
                            }
                            offer.id = 0;
                            offer.rfqSupplierId = 0;
                            offer.unitCost = "0";
                            offer.note = "";
                            offer.isWinner = false;
                            offer.totalAmt = 0;
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        addAttachment(row) {
            this.$emit('addAttachment', row)
        },
        async openPO(item) {
            if(item.containsRealignedItem){
                return this.showToast("This RFQ contains realigned items. Please remove them first.", "warning");
            }
            item.loadingPoNumber = true;
            this.openPopUp = true;
            let poNumber = await this.getPONumber();
            item.loadingPoNumber = false;
            this.po = {
                description: item.description,
                cycle: this.$store.state.data.cycle,
                rfqSupplierId: 0,
                poDateReceived: this.getDate(new Date()),
                poDate: this.getDate(new Date()),
                poNumber: poNumber,
            };
        },
        async getPONumber(){
            let poNumber = '';
            await this.$store.dispatch("po/GetPONumber", {cycle: this.$store.state.data.cycle, campusId: this.$store.state.data.selectedCampus.id}).then((res) => {
                if (res.data.error) {
                    this.showToast(res.data.errorMessage, "error");
                    return;
                }
                poNumber = res.data;
            });
            return poNumber;
        },
        async generatePO() {
            for (const x of this.data.rfqSuppliers) {
                if (x.isWinner && !x.withPo) {
                    var dat = {
                        ...this.po,
                        rfqSupplierId: x.id,
                        campusId: this.$store.state.data.selectedCampus.id,
                        deliveryInDays: 0,
                    };
                    await this.$store
                        .dispatch("po/CreatePo", dat)
                        .then((res) => {
                            this.showToast("Successfully generated P.O - " + x.supplier.name, "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                x.supplier.name -
                                    +"P.O Generation unsuccessful",
                                "error"
                            );
                        });
                }
            }
            this.openPopUp = false;
            this.data.poExist = true;
        },
    }
}
</script>
<template>
    <div>
        <div class=" d-flex align-items-center justify-content-between mb-3">
            <p
                class="mb-0" 
                :class="{
                    'text-success': data.supplierMsgType === 'success',
                    'text-danger': data.supplierMsgType === 'danger',
                }"
                v-if="data.supplierMessage"
            >
                {{ data.supplierMessage }}
            </p>
            <div class="d-flex" v-if="(data.invitedSuppliers.length == 0 && !data.itemLoading && data.supCategory == 1) || (!data.itemLoading && data.rfqSuppliers.length == 0 && data.supCategory == 2) ">
                <p class="mb-0">No suppliers found </p>
            </div>
            <div v-if="data.itemLoading || (data.supCategory == 1 && !data.itemLoading)"></div>
            <div class="d-flex align-items-center" v-if="data.supCategory == 2 && data.rfqSuppliers.length != 0 && !data.itemLoading">
                View: 
                <div class="border p-1 px-2 ms-1 cursor-pointer" :class="{'border border-success': abstractList == 1}" @click="abstractList = 1">
                    <i class="font-size-20 bx bx-list-ol" :class="{'text-success': abstractList == 1}"></i>
                </div>
                <div class="border py-1 px-2 ms-1 cursor-pointer" :class="{'border border-success': abstractList == 2}" @click="abstractList = 2">
                    <i class="font-size-20 bx bxl-microsoft " :class="{'text-success': abstractList == 2}"></i>
                </div>
                <div class="ms-2" v-if="abstractList == 2">
                    <input type="text" class="form-control" v-model="data.searchItem" placeholder="Search Item"/>
                </div>
            </div>
            <div class="d-flex align-items-center" v-if="rfqType !== 'processed'">
                <p class="mb-0 me-1 no-wrap">Select Category:</p>
                <select class="form-select me-2 text-yellow" style="width:120px;" v-model="data.supCategory">
                    <option value="1">Invited</option>
                    <option value="2">Actual</option>
                </select>
                <a
                    href="javascript:void(0);"
                    class="text-primary border-primary border p-2 no-wrap"
                    :id="`supplier-popover-${data.id}`"
                    @click="addMoreSupplier"
                    v-if="!data.reAward"
                >
                    <i class="bx bx-plus"></i>
                    Add More Supplier
                </a>
                <b-popover
                    :target="`supplier-popover-${data.id}`"
                    triggers="click"
                    placement="left"
                    custom-class="popover-supplier"
                    :show.sync="data.addSupplier"
                >
                    <template v-slot:title>
                        <div class="d-flex align-items-center justify-content-between">
                            <small class="text-dark">Add More Supplier</small>
                            <span 
                                class="bx bx-x font-size-14 cursor-pointer text-dark"
                                @click="data.addSupplier = false"
                            ></span>
                        </div>
                    </template>
                    <multiselect
                        v-model="addSupplier"
                        :options="suppliers"
                        label="name"
                        track-by="id"
                        value="id"
                        :allow-empty="false"
                        :class="{'is-invalid':submitted &&$v.addSupplier.$error}"
                    />
                    <div 
                        v-if="submitted && $v.addSupplier.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.addSupplier.required">This value is required.</span>
                    </div>
                    <hr />
                    <div class="text-right">
                        <button
                            type="button"
                            class="btn btn-success btn-sm me-1"
                            @click="addSup"
                        >
                            <i class="bx bx-save me-1"></i>Add
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm"
                            @click="data.addSupplier = false"
                        >
                            <i class="bx bx-x me-1"></i>Cancel
                        </button>
                    </div>
                </b-popover>
            </div>
        </div>
        <div class="my-3" v-if="data.itemLoading">
            <LoadingTemplate />
        </div>
        <template v-if="data.supCategory == 1">
            <b-card
                no-body
                class="mb-1 shadow-none"
                v-for="(y, index) in data.invitedSuppliers"
                :key="y.id"
            >
                <RawData 
                    :data="y" 
                    v-if="$store.state.decrypt.isAdmin()" 
                    placement="left"
                    :keyId="`supplier-offer-${data.id}${y.id}`"
                />
                <b-card-header
                    header-tag="header"
                    role="tab"
                    class="border"
                >
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <div 
                                style="min-width: 30px;"
                                class="bg-success bg-gradient text-center me-2 py-1"
                            >
                                <h3 class="mb-0">
                                    {{ index + 1 }}
                                </h3>
                            </div>
                            <div>
                                <h5 class="mb-0">
                                    {{ y.supplierName}}
                                </h5>
                                <div class="d-flex align-items-center">
                                    <small class="me-1">
                                        {{ y.address}}
                                    </small>
                                        |
                                        <small class="cursor-pointer me-1" @click="removeSup(y.id)">
                                            <b class="ms-1 text-danger">
                                                <i class="bx bx-trash"></i>
                                                Remove Supplier
                                            </b>
                                        </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card-header>
            </b-card>
        </template>
        <template v-else>
            <template v-if="abstractList == 1">
                <b-card
                    no-body
                    class="mb-1 shadow-none"
                    v-for="(y, index) in data.rfqSuppliers"
                    :key="y.id"
                >
                    <RawData 
                        :data="y" 
                        v-if="$store.state.decrypt.isAdmin()" 
                        placement="left"
                        :keyId="`supplier-offer-${data.id}${y.id}`"
                    />
                    <b-card-header
                        header-tag="header"
                        role="tab"
                        class="border"
                    >
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <div 
                                    style="min-width: 30px;"
                                    class="bg-success bg-gradient text-center me-2 py-1"
                                >
                                    <h3 class="mb-0">
                                        {{ index + 1 }}
                                    </h3>
                                </div>
                                <div>
                                    <h5 class="mb-0">
                                        {{ y.supplier.name}}
                                    </h5>
                                    <div class="d-flex align-items-center">
                                        <small class="me-1">
                                            {{ y.supplier.address}}
                                        </small>
                                        <template v-if="!data.reAward">
                                            |
                                            <small class="cursor-pointer me-1" @click="removeSup(y.id)">
                                                <b class="ms-1 text-danger">
                                                    <i class="bx bx-trash"></i>
                                                    Remove Supplier
                                                </b>
                                            </small>
                                            |
                                            <div class="form-check form-checkbox-outline form-check-success mb-0 mx-2">
                                                <input
                                                    autocomplete="off"
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    :id="`did-not-submit-${y.id}`"
                                                    v-model="y.didNotSubmit"
                                                    @click="didNotSubmit(y)"
                                                />&nbsp;&nbsp;
                                                <label class="form-check-label" :for="`did-not-submit-${y.id}`">
                                                    Did Not Submit
                                                </label>
                                            </div>
                                            |
                                            <div class="ms-2">
                                                <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                    <input
                                                        type="checkbox"
                                                        :id="`cod-${y.id}`"
                                                        class="form-check-input"
                                                        v-model="y.isCod"
                                                        @click="cashOnDelivery(y)"
                                                    />&nbsp;&nbsp;
                                                    <label :for="`cod-${y.id}`" class="form-check-label">
                                                        Cash on Delivery?
                                                    </label>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="d-flex align-items-center"
                                v-if="!y.didNotSubmit"
                            >
                                <button
                                    class="btn border-success me-3 text-success"
                                    type="button"
                                    @click="updateOffer(y.supplierRFQ, index, y.id, y.rfqReturnDate)"
                                    v-if="!data.reAward"
                                >
                                    Update Offer
                                </button>
                                <a
                                    href="javascript: void(0);"
                                    class="
                                        d-flex
                                        align-items-center
                                        text-info
                                    "
                                    @click="
                                        y.visible =
                                            !y.visible
                                    "
                                >
                                    {{
                                        y.visible
                                            ? "Hide"
                                            : "Show"
                                    }}
                                    Offer
                                    <i
                                        class="
                                            bx
                                            bx-chevron-right
                                            rotate
                                            font-size-14
                                        "
                                        :class="{
                                            'rotate-90':
                                                y.visible,
                                        }"
                                    ></i>
                                </a>
                            </div>
                        </div>
                    </b-card-header>
                    <b-collapse
                        :visible="y.visible"
                        :accordion="`${rfqType}-posted-supplier-${y.id}`"
                        role="tabpanel"
                    >
                        <div
                            class="
                                px-2
                                py-1
                            "
                        >
                            <table
                                class="
                                    table
                                    table-bordered
                                "
                            >
                                <thead>
                                    <tr>
                                        <th>
                                            Item
                                            Name
                                            <div>
                                                <small
                                                    >Item
                                                    Description</small
                                                >
                                            </div>
                                        </th>
                                        <th
                                            style="
                                                width: 120px;
                                            "
                                        >
                                            Unit
                                        </th>
                                        <th
                                            style="
                                                width: 70px;
                                            "
                                        >
                                            Qty
                                        </th>
                                        <th
                                            style="
                                                width: 150px;
                                            "
                                        >
                                            Unit
                                            Cost
                                        </th>
                                        <th
                                            style="
                                                width: 150px;
                                            "
                                        >
                                            Total
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(z, zIndex) in y.supplierRFQ">
                                        <tr :key="z.id">
                                            <td class="position-relative">
                                                <div class="position-absolute bg-purple text-center item-index">
                                                    <span class="badge">
                                                        {{ zIndex + 1 }}
                                                    </span>
                                                </div>
                                                {{ z.itemName }}
                                                <div>
                                                    <small>{{z.description}}</small>
                                                </div>
                                            </td>
                                            <td>{{z.unit.shortName}}</td>
                                            <td>{{ z.quantity }}</td>
                                            <td>{{ formatCurrency(z.unitCost)}}</td>
                                            <td>{{formatCurrency(z.total)}}</td>
                                        </tr>
                                        <template v-if="z.offer.noOffer">
                                            <tr :key="`no-offer-${z.id}`">
                                                <td colspan="5" class="text-center">
                                                    <i>No offer...</i>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr 
                                                :key="`offer-${z.id}`" 
                                                v-if="z.offer.id > 0"
                                                class="custom-border-2"
                                            >
                                                <td class="position-relative">
                                                    <div class="bg-secondary bg-soft rotate-270">
                                                        <span class="badge">
                                                            Item Offer
                                                        </span>
                                                    </div>
                                                    {{ z.offer.itemName }}
                                                    <div>
                                                        <small>{{ z.offer.description}}</small>
                                                    </div>
                                                    <div>
                                                        <p class="mb-0" v-if="z.offer.deliveryPeriod">{{z.offer.deliveryPeriod}} calendar day(s)</p>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <a
                                                                href="javascript:void(0);"
                                                                :id="`moreSpecView${z.offer.id}`"
                                                                ><i
                                                                    class="
                                                                        mdi mdi-triangle
                                                                        rotate rotate-90
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >More Specifications</a
                                                            >
                                                            <b-popover
                                                                :target="`moreSpecView${z.offer.id}`"
                                                                triggers="click"
                                                                placement="right"
                                                                :show.sync="z.offer.showMoreSpec"
                                                                custom-class="popover-supplier"
                                                            >
                                                                <template v-slot:title>
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-between
                                                                        "
                                                                    >
                                                                        <small
                                                                            >More Specifications</small
                                                                        >
                                                                        <span
                                                                            class="
                                                                                bx bx-x
                                                                                font-size-14
                                                                                cursor-pointer
                                                                            "
                                                                            @click="
                                                                                z.offer.showMoreSpec = false
                                                                            "
                                                                        ></span>
                                                                    </div>
                                                                </template>
                                                                <div class="row mb-2">
                                                                    <div class="col-md-6">
                                                                        <label for="" class="mb-0"
                                                                            >Brand</label
                                                                        >
                                                                        <div
                                                                            type="text"
                                                                            placeholder="Enter Brand"
                                                                            class="
                                                                                form-control
                                                                                form-control-sm text-warning
                                                                            "
                                                                        >
                                                                            {{z.offer.brand}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <label for="" class="mb-0"
                                                                            >Model</label
                                                                        >
                                                                        <div
                                                                            class="
                                                                                form-control
                                                                                form-control-sm text-warning
                                                                            "
                                                                            
                                                                        >
                                                                            {{z.offer.model}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row mb-2">
                                                                    <div class="col-md-6">
                                                                        <label for="" class="mb-0"
                                                                            >Color</label
                                                                        >
                                                                        <div
                                                                            class="
                                                                                form-control
                                                                                form-control-sm text-warning
                                                                            "
                                                                        >
                                                                            {{z.offer.color}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <label for="" class="mb-0"
                                                                            >Condition</label
                                                                        >
                                                                        <div
                                                                            class="
                                                                                form-control
                                                                                form-control-sm text-warning
                                                                            "
                                                                        >
                                                                            {{z.offer.condition}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row mb-2">
                                                                    <div class="col-md-6">
                                                                        <label for="" class="mb-0"
                                                                            >Material Used</label
                                                                        >
                                                                        <div
                                                                            class="
                                                                                form-control
                                                                                form-control-sm text-warning
                                                                            "
                                                                        >
                                                                            {{z.offer.materialUsed}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <label for="" class="mb-0"
                                                                            >Package Description</label
                                                                        >
                                                                        <div
                                                                            class="
                                                                                form-control
                                                                                form-control-sm text-warning
                                                                            "
                                                                        >
                                                                            {{z.offer.packageDescription}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="mb-2">
                                                                    <label for="" class="mb-0"
                                                                        >Dimension Description</label
                                                                    >
                                                                    <div
                                                                        class="
                                                                            form-control form-control-sm text-warning
                                                                        "
                                                                    >
                                                                        {{z.offer.dimensionDescription}}
                                                                    </div>
                                                                </div>
                                                                <div class="mb-2">
                                                                    <label for="" class="mb-0"
                                                                        >Other Specifications</label
                                                                    >
                                                                    <div
                                                                        class="
                                                                            form-control form-control-sm text-warning
                                                                        "
                                                                    >
                                                                        {{z.offer.specification}}
                                                                    </div>
                                                                </div>
                                                                <div class="mb-2">
                                                                    <label for="" class="mb-0"
                                                                        >Notes</label
                                                                    >
                                                                    <div
                                                                        class="
                                                                            form-control form-control-sm
                                                                            text-warning
                                                                        "
                                                                    >
                                                                        {{
                                                                            z.offer.note
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </b-popover>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {{
                                                        z
                                                            .offer
                                                            .unit
                                                            .shortName
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        z
                                                            .offer
                                                            .quantity
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        formatCurrency(
                                                            z
                                                                .offer
                                                                .unitCost
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        position-relative
                                                    "
                                                >
                                                    <div
                                                        class="
                                                            position-absolute
                                                            cursor-pointer
                                                            d-flex
                                                        "
                                                        style="
                                                            right: 0;
                                                            top: -12px;
                                                        "
                                                    >
                                                        <div
                                                            @click="markAsWinner(z.offer)"
                                                            class="me-1"
                                                            v-if="!data.reAward"
                                                        >
                                                            <span
                                                                class="
                                                                    badge
                                                                    px-1
                                                                "
                                                                :class="{
                                                                    'bg-success':
                                                                        !z
                                                                            .offer
                                                                            .isWinner,
                                                                    'bg-warning bg-gradient':
                                                                        z
                                                                            .offer
                                                                            .isWinner,
                                                                }"
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-check
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >{{
                                                                    z
                                                                        .offer
                                                                        .isWinner
                                                                        ? "Remove as winner"
                                                                        : "Mark as winner"
                                                                }}</span
                                                            >
                                                        </div>
                                                        <div @click="removeOffer(z.offer)"  v-if="!data.reAward"
                                                        >
                                                            <span
                                                                class="
                                                                    badge
                                                                    bg-danger
                                                                    px-1
                                                                "
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-trash
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Remove
                                                                offer</span
                                                            >
                                                        </div>
                                                    </div>
                                                    {{
                                                        formatCurrency(
                                                            parseFloat(
                                                                z
                                                                    .offer
                                                                    .unitCost
                                                            ) *
                                                                parseFloat(
                                                                    z
                                                                        .offer
                                                                        .quantity
                                                                )
                                                        )
                                                    }}
                                                    <div
                                                        class="
                                                            mt-2
                                                            text-center
                                                        "
                                                        v-if="
                                                            z
                                                                .offer
                                                                .isWinner
                                                        "
                                                    >
                                                        <small
                                                            class="
                                                                badge
                                                                bg-success
                                                                px-2
                                                            "
                                                            ><i
                                                                class="
                                                                    bx
                                                                    bx-crown
                                                                "
                                                            ></i
                                                            >Winner</small
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                :key="`no-offer-yet-${z.id}`"
                                                v-else
                                            >
                                                <td
                                                    colspan="5"
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    <i
                                                        >No
                                                        offer
                                                        yet</i
                                                    >
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <tr
                                        class="
                                            border
                                            border-dashed
                                        "
                                    >
                                        <td
                                            class="
                                                py-2
                                            "
                                            colspan="3"
                                        ></td>
                                        <td
                                            class="
                                                text-right
                                                py-2
                                                px-2
                                            "
                                        >
                                            Total ABC as Awarded:
                                        </td>
                                        <td
                                            colspan="2"
                                            class="
                                                py-2
                                            "
                                        >
                                            {{ formatCurrency(getTotalABC(y.supplierRFQ)) }}
                                        </td>
                                    </tr>
                                    <tr
                                        class="
                                            border
                                            border-dashed
                                        "
                                    >
                                        <td
                                            class="
                                                py-2
                                            "
                                            colspan="3"
                                        >
                                            <div>
                                                <button
                                                    type="button"
                                                    class="btn btn-link"
                                                    @click="addAttachment(y)"
                                                >
                                                    <i class="mdi mdi-paperclip"></i> Attachments
                                                </button>
                                            </div>
                                        </td>
                                        <td
                                            class="
                                                text-right
                                                py-2
                                                px-2
                                            "
                                        >
                                            Total Awarded Amount:
                                        </td>
                                        <td
                                            colspan="2"
                                            class="py-2"
                                        >
                                            {{ formatCurrency(getTotalOffer(y.supplierRFQ)) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-collapse>
                </b-card>
            </template>
            <template v-else>
                <template v-if="!data.itemLoading">
                    <div class="custom-table-responsive">
                        <table class="table table-bordered" style="width:unset !important;">
                            <thead>
                                <tr>
                                    <th width="100px">Qty/Unit</th>
                                    <th width="200px">Item</th>
                                    <th width="150px">Unit Cost</th>
                                    <template v-for="(z, index) in data.rfqSuppliers">
                                        <th :key="`Supplier-${z.id}`" width="300px" style="vertical-align:top">
                                            <span class="text-warning d-inline">
                                                {{ z.supplier.name }} 
                                                <a href="javascript:void(0);"  v-if="!data.reAward" @click="updateOffer(z.supplierRFQ, index, z.id, z.rfqReturnDate, data.id)"><i class="bx bx-edit"></i></a>
                                                <a href="javascript:void(0);"  v-if="!data.reAward" class="text-danger" @click="removeSup(z.id)"><i class="bx bx-trash"></i></a>
                                            </span>
                                            <div class="text-ellipsis" style="width:300px;">
                                                <small>{{z.supplier.address}}</small>
                                            </div>
                                            <div class="form-check form-checkbox-outline form-check-success mb-0" v-if="!data.reAward">
                                                <input
                                                    autocomplete="off"
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    :id="`did-not-submit-${z.id}`"
                                                    v-model="z.didNotSubmit"
                                                    @click="didNotSubmit(z)"
                                                />&nbsp;&nbsp;
                                                <label class="form-check-label" :for="`did-not-submit-${z.id}`">
                                                    Did Not Submit
                                                </label>
                                            </div>
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="filteredRfqItems.length > 0">
                                    <template v-for="z in filteredRfqItems">
                                        <tr :key="z.id">
                                            <td>{{ z.quantity }} {{ z.unit.shortName }}</td>
                                            <td>{{ z.itemName }}</td>
                                            <td>{{ formatCurrency(z.unitCost) }}</td>
                                            <template v-for="y in data.rfqSuppliers">
                                                <td :key="`Supplier-Offer-${y.id}`" class="position-relative">
                                                    <template v-if="y.didNotSubmit">
                                                        <div><i>Did not Submit</i></div>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="getOffer(y.supplierRFQ, z.id).offer.id > 0">
                                                            <template v-if="getOffer(y.supplierRFQ, z.id).offer.noOffer">
                                                                <div class="text-center">
                                                                    <i>Supplier has no offer</i>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="position-absolute isWinner" v-if="getOffer(y.supplierRFQ, z.id).offer.isWinner"></div>
                                                                <div class="mb-1"><i>{{ getOffer(y.supplierRFQ, z.id).offer.itemName}}</i></div>
                                                                <div>
                                                                    Qty: <span class="text-warning">{{ getOffer(y.supplierRFQ, z.id).offer.quantity }}</span>
                                                                </div>
                                                                <div>
                                                                    Price: <span class="text-warning">{{ formatCurrency(getOffer(y.supplierRFQ, z.id).offer.unitCost)}}</span>
                                                                </div>
                                                                <div>
                                                                    Total: <span class="text-warning">{{ formatCurrency(parseFloat(
                                                                        getOffer(y.supplierRFQ, z.id)
                                                                        .offer
                                                                        .unitCost
                                                                ) *
                                                                    parseFloat(
                                                                        getOffer(y.supplierRFQ, z.id)
                                                                            .offer
                                                                            .quantity
                                                                    ))}}</span>
                                                                </div>
                                                                <div class="d-flex align-items-center" v-if="!data.reAward">
                                                                    <div
                                                                        @click="markAsWinner(getOffer(y.supplierRFQ, z.id).offer)"
                                                                        class="me-1 cursor-pointer"
                                                                    >
                                                                        <span
                                                                            class="
                                                                                badge
                                                                                px-1
                                                                            "
                                                                            :class="{
                                                                                'bg-success': !getOffer(y.supplierRFQ, z.id).offer.isWinner,
                                                                                'bg-warning bg-gradient': getOffer(y.supplierRFQ, z.id).offer.isWinner,
                                                                            }"
                                                                        >
                                                                            <i class="bx bx-check me-1"></i>
                                                                            {{ getOffer(y.supplierRFQ, z.id).offer.isWinner ? "Remove as winner" : "Mark as winner" }}
                                                                        </span>
                                                                    </div>
                                                                    <div
                                                                        @click="removeOffer(getOffer(y.supplierRFQ, z.id).offer)"
                                                                        class="cursor-pointer"
                                                                    >
                                                                        <span
                                                                            class="
                                                                                badge
                                                                                bg-danger
                                                                                px-1
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-trash
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Remove
                                                                            offer</span
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </template>
                                                        <div v-else>No offer yet</div>
                                                    </template>
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="100%" class="text-center">
                                            Search not found
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </template>
            </template>
        </template>
        <template v-if="rfqType === 'processed' && !data.poExist">
            <hr />
            <div class="">
                <button
                    type="button"
                    class="btn btn-info"
                    :id="`gpo-popover-${data.id}`"
                    @click="openPO(data)"
                >
                    <i
                        class="
                            bx
                            bxs-printer
                            me-1
                        "
                    ></i
                    >Generate P.O
                </button>
                <b-popover
                    :target="`gpo-popover-${data.id}`"
                    triggers="click"
                    placement="righttop"
                    custom-class="popover-supplier"
                    :show.sync="openPopUp"
                    v-if="!data.poExist"
                >
                    <!-- && data.bacApproved -->
                    <template
                        v-slot:title
                    >
                        <div class="d-flex align-items-center justify-content-between">
                            <small>Generate P.O</small>
                            <span 
                                class="bx bx-x font-size-14 cursor-pointer"
                                @click="openPopUp = false"
                            ></span>
                        </div>
                    </template>
                    <div class="position-relative">
                        <div class="position-absolute d-flex align-items-center justify-content-center loading-po" v-if="data.loadingPoNumber">
                            <div
                                class="
                                    spinner-border
                                    text-primary
                                    spinner-border-sm
                                "
                                role="status"
                            >
                                <span class="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                        </div>
                        <div class="mb-2">
                            <label>P.O Description</label>
                            <textarea
                                v-model="po.description"
                                placeholder="Enter P.O Description"
                                rows="5"
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.po
                                            .description
                                            .$error,
                                }"
                            ></textarea>
                            <div
                                v-if="
                                    submitted &&
                                    $v.po
                                        .description
                                        .$error
                                "
                                class="
                                    invalid-feedback
                                "
                            >
                                <span
                                    v-if="
                                        !$v.po
                                            .description
                                            .required
                                    "
                                    >This value
                                    is
                                    required.</span
                                >
                            </div>
                        </div>
                        <div>
                            <label>P.O Number</label>
                            <input
                                v-model="
                                    po.poNumber
                                "
                                placeholder="Enter P.O Number"
                                rows="5"
                                class="
                                    form-control
                                "
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.po
                                            .poNumber
                                            .$error,
                                }"
                            />
                            <div
                                v-if="
                                    submitted &&
                                    $v.po
                                        .poNumber
                                        .$error
                                "
                                class="
                                    invalid-feedback
                                "
                            >
                                <span
                                    v-if="
                                        !$v.po
                                            .poNumber
                                            .required
                                    "
                                    >This value
                                    is
                                    required.</span
                                >
                            </div>
                        </div>
                        <hr />
                        <div
                            class="
                                text-right
                            "
                        >
                            <button
                                type="button"
                                class="
                                    btn
                                    btn-info
                                    btn-sm
                                    me-1
                                "
                                @click="generatePO(data)"
                            >
                                <i
                                    class="
                                        bx
                                        bx-save
                                        me-1
                                    "
                                ></i
                                >Generate
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm"
                                @click="openPopUp = false"
                            >
                                <i
                                    class="
                                        bx
                                        bx-x
                                        me-1
                                    "
                                ></i
                                >Cancel
                            </button>
                        </div>
                        <div
                            v-if="
                                data.generatingPO
                            "
                        >
                            <p
                                class="mb-0"
                                :class="{
                                    'text-success':
                                        data.itemMsgType ===
                                        'success',
                                    'text-danger':
                                        data.itemMsgType ===
                                        'danger',
                                }"
                            >
                                {{
                                    data.itemMessage
                                }}
                            </p>
                        </div>
                    </div>
                </b-popover>
            </div>
        </template>
  </div>
</template>